function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0514 2.42756C13.5291 0.361625 16.4709 0.361629 16.9486 2.42757L18.7636 10.2774C18.9464 11.0682 19.5891 11.67 20.3902 11.8007L27.901 13.0261C30.1383 13.3911 30.1383 16.6089 27.901 16.9739L20.3902 18.1993C19.5891 18.33 18.9464 18.9318 18.7636 19.7226L16.9486 27.5724C16.4709 29.6384 13.5291 29.6384 13.0514 27.5724L11.2364 19.7226C11.0536 18.9318 10.4109 18.33 9.60985 18.1993L2.09899 16.9739C-0.1383 16.6089 -0.138306 13.3911 2.09898 13.0261L9.60985 11.8007C10.4109 11.67 11.0536 11.0682 11.2364 10.2774L13.0514 2.42756Z",
  fill: "#7E8897"
});

function SvgStarBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBig);
export default __webpack_public_path__ + "static/media/starBig.6f4718c8.svg";
export { ForwardRef as ReactComponent };